<div class="pia-revisions hide-for-print">
  <div class="pia-revisions-title" *ngIf="title">
    <fa-icon [icon]="faHistory"></fa-icon>
    {{ "summary.revision.revision" | translate }}
  </div>
  <div class="pia-revisions-box" *ngIf="revisions">
    <h4>{{ "summary.revision.pia_version" | translate }}</h4>
    <p>
      <fa-icon [icon]="faCircle"></fa-icon>
      {{ currentVersion | date: "short":"":languagesService.selectedLanguage }}
      - {{ "summary.revision.current_version" | translate }}
    </p>
    <a
      *ngIf="revisions.length > 0"
      href="javascript;"
      class="pia-revisions-box-footer"
      (click)="opened = !opened; $event.preventDefault()"
    >
      <span>{{
        "summary.revision.show" | translate: { length: revisions.length }
      }}</span>
      <fa-icon [icon]="faChevronDown" *ngIf="!opened; else close"></fa-icon>
      <ng-template #close>
        <fa-icon [icon]="faChevronUp"></fa-icon>
      </ng-template>
    </a>
    <div
      *ngIf="opened && revisionsGroupByMonth"
      class="pia-revisions-box-content"
    >
      <div
        class="pia-revisions-box-content-revision"
        *ngFor="let date of revisionsGroupByMonthInArray.reverse()"
      >
        <h5>{{ date }}</h5>
        <ul>
          <li
            *ngFor="let revision of revisionsGroupByMonth[date]"
            class="pia-revisions-box-content-revision-item"
            [attr.revision-id]="revision.id"
          >
            <span
              (click)="
                previewRevision(revision.id, $event, revision.created_at)
              "
            >
              <fa-icon
                [icon]="faCircle"
                class="revision-not-selected "
              ></fa-icon>
              <fa-icon
                [icon]="faCircleCheck"
                class="revision-selected hide"
              ></fa-icon>
              {{
                revision.created_at
                  | date: "short":"":languagesService.selectedLanguage
              }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <button
      class="pia-revisions-new"
      *ngIf="
        ['author', 'validator', 'evaluator'].indexOf(editMode[0]) >= 0 ||
        editMode === 'local'
      "
      (click)="newRevision()"
    >
      <span class="pia-icons pia-icon-add-white"></span>
      {{ "summary.revision.save" | translate }}
    </button>
  </div>
</div>
<app-modal
  *ngIf="preview"
  (clickOnClose)="preview = null"
  specialClass="revision-preview-modal"
>
  <app-revision-preview
    *ngIf="preview"
    [revision]="preview"
    [editMode]="editMode"
  >
  </app-revision-preview>
</app-modal>
